import { useState, useRef } from "react";
import { rebuildFormula } from "@/config/func";
import { Button, Space, Modal, Checkbox } from "antd";
import { BranchesOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { useAppContext } from "@/AppContext";

const TableLine = (props: any) => {
  const {
    source,
    isSelected,
    onSelect,
    maxSelected,
    setCurSource,
    setIsModalOpen,
  } = props;
  const { state, actions } = useAppContext();
  const { materials, flowMode } = state;
  const { setMaterials } = actions;
  const deleteLine = () => {
    let result = materials.filter((v: any) => {
      return [source].every(
        (n: any) => JSON.stringify(n) !== JSON.stringify(v)
      );
    });
    setMaterials(result);
  };

  return (
    <>
      <tr>
        {/* 修改进料数据源统一注释 */}
        {/* <td style={{ width: "5%" }}>
          <Checkbox
            style={{ margin: "0 1rem" }}
            checked={isSelected}
            onChange={(e) => onSelect(e.target.checked)}
            disabled={maxSelected && !isSelected}
          />
        </td> */}
        <td>{rebuildFormula(source.formula)}</td>
        <td>{source.name}</td>
        <td>{rebuildFormula(source.formula)}</td>
        <td>{source.ename}</td>
        <td>{source.cas_code}</td>
        {flowMode !== "查看流程" ? (
          <td>
            <Space>
              {/* 修改进料数据源统一注释 */}
              {/* <Button
              icon={<BranchesOutlined />}
              onClick={() => {
                setCurSource(source);
                setIsModalOpen(true);
              }}
            >
              物性数据
            </Button> */}
              <Button danger onClick={deleteLine}>
                <CloseCircleOutlined /> 删除
              </Button>
            </Space>
          </td>
        ) : null}

      </tr>
    </>
  );
};

export default TableLine;
